const project = {
    getlist: 'project/getlist-by-admin',
    add: 'project/add',
    update: 'project/update',
    remove: 'project/remove',
    get: 'project/get-by-admin',
    getall: 'project/getall',
}
export default project
